import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'
import settings from './settings'
import auth from './auth'
import network from './network'
import intl from './intl'
import dispatch from './dispatch'
import termsandconditions from './termsandconditions'
import apis from './apis'
import search from './search'
import options from './options'

export default combineReducers({
  router: routerReducer,
  settings,
  options,
  auth,
  network,
  intl,
  dispatch,
  apis,
  search,
  termsandconditions,
})



// WEBPACK FOOTER //
// ./src/modules/index.js